module.exports = __webpack_public_path__ + "static/img/12.5bfa7c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/12.png
// module id = CrsE
// module chunks = 0